export class BandsintownWidget extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const artistId = this.getAttribute('artist-id');
		if (!artistId) {
			console.error('Artist ID is required for BandsintownWidget');
		}
		this.getArtistEvents(artistId);
	}

	getArtistEvents(artistId) {
		const url = `https://rest.bandsintown.com/artists/${artistId}/events/?app_id=yOUrSuP3r3ven7aPp-id`;
		fetch(url)
			.then((response) => {
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				return response.json();
			})
			.then((data) => {
				// this.renderEvents(data);
				console.log('Fetched events:', data);
			})
			.catch((error) => {
				console.error('Error fetching events:', error);
			});
	}
}
